export const ValidationRegExp = {
  name: /^[\p{L}\s]+$/u,
  email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  text: /^([A-Za-zа-яА-Я0-9іІїЇЄєґҐ]|!|\?|@|\.|,|\s|;|:|')+$/i,
  phoneNumber: /^([\s\-\(0-9\)\s\-]{2,8})?(\-?[0-9\s]\-?){5,20}$/,
  dialCode: /^(\+?[0-9\s]\-?)$/,
  inputIntegers: /(^\d+$)|(^$)/,
} as const;
